import React from 'react';
import { Row, Col, Container } from 'react-bootstrap';

const Enterprise = () => {
    return (
        <>
            {/* Enterprise Consulting Section */}
            <section className="py-5 bg-dark" style={{paddingTop: '8rem'}} id="enterprise">
                <Container>
                    <Row className="justify-content-center">
                        <Col xs={12} lg={12}>
                            <div className="text-center mb-5">
                                <h2 className="display-2 mb-4">
                                    Enterprise <span className="text-gradient">AI Video Solutions</span>
                                </h2>
                                <p className="lead mb-5">Transform your data into compelling AI video summaries that highlight key metrics, identify insights, and summarize performance for your organization.</p>
                            </div>
                            <Row className="g-4">
                                <Col xs={12} md={4} className="mb-4">
                                    <div className="feature-card text-center d-flex flex-column h-100" style={{padding: '30px'}}>
                                        <div className="feature-icon mb-4 flex-shrink-0" style={{minHeight: '80px', paddingTop: '20px'}}>
                                            <i className="fas fa-brain fa-3x text-primary"></i>
                                        </div>
                                        <h3 className="h4 mb-3 flex-shrink-0" style={{minHeight: '60px'}}>AI Video Summaries</h3>
                                        <p className="text-muted flex-grow-1">Generate intelligent video summaries from your data that highlight key metrics, trends, and performance insights in an engaging, easy-to-understand format.</p>
                                    </div>
                                </Col>
                                <Col xs={12} md={4} className="mb-4">
                                    <div className="feature-card text-center d-flex flex-column h-100" style={{padding: '30px'}}>
                                        <div className="feature-icon mb-4 flex-shrink-0" style={{minHeight: '80px', paddingTop: '20px'}}>
                                            <i className="fas fa-shield-alt fa-3x text-primary"></i>
                                        </div>
                                        <h3 className="h4 mb-3 flex-shrink-0" style={{minHeight: '60px'}}>Data Privacy Protection</h3>
                                        <p className="text-muted flex-grow-1">Enterprise-grade data privacy protections ensure your sensitive information remains secure throughout the entire video generation process.</p>
                                    </div>
                                </Col>
                                <Col xs={12} md={4} className="mb-4">
                                    <div className="feature-card text-center d-flex flex-column h-100" style={{padding: '30px'}}>
                                        <div className="feature-icon mb-4 flex-shrink-0" style={{minHeight: '80px', paddingTop: '20px'}}>
                                            <i className="fas fa-handshake fa-3x text-primary"></i>
                                        </div>
                                        <h3 className="h4 mb-3 flex-shrink-0" style={{minHeight: '60px'}}>One-to-One Consulting</h3>
                                        <p className="text-muted flex-grow-1">Personalized consulting service tailored to your specific needs, helping you maximize the value of your data through custom AI video solutions.</p>
                                    </div>
                                </Col>
                            </Row>
                            
                            {/* CTA Section */}
                            <Row className="justify-content-center mt-5">
                                <Col xs={12} lg={8}>
                                    <div className="glass-card text-center" style={{padding: '3rem 2rem'}}>
                                        <h3 className="h2 mb-4">
                                            Ready to transform your <span className="text-gradient">data into stories</span>?
                                        </h3>
                                        <p className="lead mb-4">Let's discuss how our AI video solutions can help your organization communicate insights more effectively.</p>
                                        <div className="d-flex justify-content-center">
                                            <div className="text-center">
                                                <p className="mb-2" style={{fontSize: '1.1rem', fontWeight: '600'}}>Contact our founder:</p>
                                                <p className="mb-0" style={{fontSize: '1.2rem', color: 'var(--accent-primary)'}}>elliot@recapvid.com</p>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
};

export default Enterprise;
